import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { apiFetch } from '../../api/apiClient';
import { toSlug } from '../../util/strings';

function Marquee({ portfolioName: portfolioNameProp }) {
  const params = useParams();
  const portfolioName = toSlug(
    portfolioNameProp || params.plantName || params.portfolioName || '',
  );
  const [notices, setNotices] = useState([]);

  useEffect(() => {
    if (!portfolioName) {
      return undefined;
    }

    let cancelled = false;

    (async () => {
      try {
        const payload = await apiFetch(`/api/weather/portfolio/${portfolioName}/happening-now`);
        if (!cancelled && Array.isArray(payload?.notices)) {
          setNotices(payload.notices.filter((notice) => String(notice || '').trim()));
        }
      } catch (error) {
        console.warn('Failed to load happening-now notices:', error);
        if (!cancelled) {
          setNotices([]);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [portfolioName]);

  if (!notices.length) {
    return null;
  }

  return (
    <div className="marquee">
      <span>
        <strong>HAPPENING NOW:</strong>
        {notices.map((notice, index) => (
          <span key={index}>
            {index > 0 ? <span className="marquee-sep">|</span> : null}
            {notice}
          </span>
        ))}
      </span>
    </div>
  );
}

export default Marquee;
